import { useLocation } from 'react-router-dom'

const useGetActiveTab = () => {
  const { pathname } = useLocation()

  return pathname
}

export default useGetActiveTab
